import ReportPage from "../../components/ReportPage";
import { downloadTotalDistributionByBanner } from "../../API";

const schema = {
  title: "Total Distribution by Banner",
  params: [
    { name: "banners", label: "Banners", type: "multiselect", route: "banners", fields: ["name"], payloadKey: "bannerIds" },
    {
      name: "products",
      label: "Products",
      type: "multiselect",
      route: "products",
      cascadesFrom: "manufacturer",
      fields: ["description", "formatQut", "format"],
      payloadKey: "productIds",
      dependsOnValues: ["banners"],
      buildQueryFn: (manufacturer, commonParams, localValues) => {
        const p = new URLSearchParams();
        p.set("manufacturerId", manufacturer.id);
        const status = localValues?.productStatus?.id ?? commonParams.itemStatus ?? "ACTIVE";
        if (status !== "ALL") p.set("status", status);
        (commonParams.provinces ?? []).forEach((pr) => p.append("provinceIds", pr.id));
        ((localValues ?? {}).banners ?? []).forEach((b) => p.append("bannerIds", b.id));
        return `/for-report-selector?${p.toString()}`;
      },
    },
  ],
  downloadFn: downloadTotalDistributionByBanner,
};

export default function TotalDistributionByBannerReport() {
  return <ReportPage schema={schema} />;
}
